import type WorkSummaryVM from 'ab-viewModels/fieldReport/workSummary.viewModel';
import type WorkSummaryDetailVM from 'ab-viewModels/fieldReport/workSummaryDetails.viewModel';

import * as ReportBlockFieldEnum from '@acceligentllc/shared/enums/reportBlockField';

export enum WorkSummaryTableSortKey {
	WORK = 'WORK',
	TYPE = 'TYPE',
	QUANITITY = 'QUANTITY',
	UNIT = 'UNIT',
}

export interface WorkSummaryTableSortMeta<K extends WorkSummaryTableSortKey> {
	id: K;
	label: string;
	sort: (a: WorkSummaryDetailVM | WorkSummaryVM, b: WorkSummaryDetailVM | WorkSummaryVM) => number;
}

export const WORK_SUMMARY_TABLE_SORT_META: { [K in WorkSummaryTableSortKey]: WorkSummaryTableSortMeta<K> } = {
	[WorkSummaryTableSortKey.TYPE]: {
		id: WorkSummaryTableSortKey.TYPE,
		label: 'Type',
		sort: (a: WorkSummaryDetailVM, b: WorkSummaryDetailVM) => {
			let compareA = a.workType ?? '';
			let compareB = b.workType ?? '';
			if (a.workTypeFieldType === ReportBlockFieldEnum.Type.EQUIPMENT) {
				try {
					if (compareA?.includes('"id":')) {
						const parsedEquipment = JSON.parse(compareA);
						compareA = parsedEquipment.id?.toString();
					}
				} catch {
					throw new Error(`Failed to parse compareA JSON: ${compareA}`);
				}
			}
			if (b.workTypeFieldType === ReportBlockFieldEnum.Type.EQUIPMENT) {
				try {
					if (compareB?.includes('"id":')) {
						const parsedEquipment = JSON.parse(compareB);
						compareB = parsedEquipment.id?.toString();
					}
				} catch {
					throw new Error(`Failed to parse compareB JSON: ${compareB}`);
				}
			}
			return (compareA ?? '').localeCompare(compareB ?? '');
		},
	},
	[WorkSummaryTableSortKey.WORK]: {
		id: WorkSummaryTableSortKey.WORK,
		label: 'Name',
		sort: (a: WorkSummaryDetailVM, b: WorkSummaryDetailVM) => a.workName.localeCompare(b.workName),
	},
	[WorkSummaryTableSortKey.QUANITITY]: {
		id: WorkSummaryTableSortKey.QUANITITY,
		label: 'Quantity',
		sort: (a: WorkSummaryDetailVM, b: WorkSummaryDetailVM) => (b.quantity ?? 0) - (a.quantity ?? 0),
	},
	[WorkSummaryTableSortKey.UNIT]: {
		id: WorkSummaryTableSortKey.UNIT,
		label: 'Unit',
		sort: (a: WorkSummaryDetailVM, b: WorkSummaryDetailVM) => (b.unit ?? '').localeCompare(a.unit ?? ''),
	},
};
